import { create } from 'zustand';

export type TabSwipeGestureMode = 'normal' | 'map-strict' | 'disabled';

type TabSwipeGuardState = {
  isBlocked: boolean;
  mode: TabSwipeGestureMode;
  setBlocked: (blocked: boolean) => void;
  setMode: (mode: TabSwipeGestureMode) => void;
};

export const useTabSwipeGuardStore = create<TabSwipeGuardState>((set) => ({
  isBlocked: false,
  mode: 'normal',
  setBlocked: (blocked) =>
    set((state) => (state.isBlocked === blocked ? state : { isBlocked: blocked })),
  setMode: (mode) => set((state) => (state.mode === mode ? state : { mode })),
}));
